import { useMemo } from 'react'
import { useSelector } from 'react-redux'
import { selectUserConfiguration } from '@/features/domain/user'
import { selectCompanies } from '@/features/domain/company'
import { useFormatEligibility } from '@/hooks'
import { aggregateOrdersData } from './aggregateOrdersData'

export function useBulkViewData(orders: uui.domain.client.rm.ExtendedOrderStep[]) {
  const { planType } = useSelector(selectUserConfiguration)
  const companiesMap = useSelector(selectCompanies)
  const archived = planType === 'archived'
  const formatEligibility = useFormatEligibility()

  return useMemo(
    () =>
      aggregateOrdersData(
        {
          orders,
          companiesMap,
          archived,
        },
        formatEligibility,
      ),
    [archived, companiesMap, orders, formatEligibility],
  )
}
